import type { JSX } from "react";
import { connect } from "react-redux";

import { useAfterHydration } from "../../../../common/helpers/afterHydration";
import taskCompleted from "../../../store/plan/actions/taskCompleted";

import TaskSwitch from "../../../components/TaskSwitch";
import ViewContainer from "../../../components/Task/ViewContainer";
import { Placeholder } from "./styles";
import { IProps } from "./interfaces";
import { ICommonTaskProps } from "../../../../common/types";

const PlayContainer = ({
    viewProps,
    publicView,
    plan,
    taskIndex,
    scaleAlert,
    flowPage,
    changeFlowPage,
    taskCompleted,
}: IProps) => {
    const afterHydration = useAfterHydration();
    const task = plan.tasks[taskIndex];
    const { type } = task;
    const props = {
        task,
        edit: true,
        publicView,
        plan,
        scaleAlert,
        flowPage,
        changeFlowPage,
        completed: (type: string) => {
            taskCompleted({
                type,
                editor: true,
                planId: plan._id,
                isExperience: false,
                page: "preview",
            });
        },
    } as unknown as ICommonTaskProps;
    // The exercise is not server rendered - it is heavy and a crawler reads nothing in
    // it - so the placeholder the server sends has to be the browser's first render too.
    if (!afterHydration) {
        return (
            <Placeholder>
                <svg viewBox="0 0 1280 720"></svg>
            </Placeholder>
        );
    }
    const Task = TaskSwitch(type) as (props: ICommonTaskProps) => JSX.Element;
    return (
        <ViewContainer viewProps={viewProps}>
            <Task {...props} />
        </ViewContainer>
    );
}

export default connect(null, { taskCompleted })(PlayContainer);
